module.exports = __webpack_public_path__ + "img/right.8c0082c6.png";